import { css } from "@emotion/core"
import { func, bool, string, number, object } from "prop-types"
import { range } from "utils/numbers"
import { Button, Text } from "@planningcenter/tapestry-react"
import { colors } from "components/shared/admin_colors"

const AttendeeTypeRow = ({
  attendeeType,
  maxSelectValue,
  onSimpleAttendeeChange,
  onWaitlistPromotion,
  isEditing = true
}) => {
  if (!isEditing && Number(attendeeType.selectedCount) === 0) {
    return null
  }

  return (
    <div key={attendeeType.id} css={attendeeTypeRow}>
      <div>
        <Text color={colors.neutral_600} paddingRight={1}>
          {attendeeType.name}
        </Text>
        {isEditing && (
          <>
            <div className="d-f font-size-4 c-neutral-600 mt-2p">
              {attendeeType.constrained_capacity === null ? (
                <span>Unlimited</span>
              ) : (
                !attendeeType.isWaitlist && (
                  <span>{attendeeType.constrained_capacity} remaining</span>
                )
              )}
              {attendeeType.isWaitlist && attendeeType.anyActiveAttendeesOnWaitlist && (
                <span>{attendeeType.activeAttendeesOnWaitlistCount} on waitlist</span>
              )}
            </div>
          </>
        )}
      </div>
      {isEditing ? (
        <div>
          {maxSelectValue <= 1 && !attendeeType.isWaitlist ? (
            <span className="danger-badge badge">Full</span>
          ) : (
            // eslint-disable-next-line jsx-a11y/no-onchange
            <select
              className="select"
              value={attendeeType.selectedCount}
              css={{ width: 80 }}
              onChange={e => onSimpleAttendeeChange(attendeeType, e.target.value)}
            >
              {range(maxSelectValue).map(num => {
                return (
                  <option key={num} value={num}>
                    {num}
                  </option>
                )
              })}
            </select>
          )}
        </div>
      ) : (
        <div
          className={`d-f ai-c jc-sb ${attendeeType.simpleAttendee &&
            attendeeType.simpleAttendee.canceled &&
            "c-neutral-500 t-strike"}`}
        >
          {!isEditing && onWaitlistPromotion && !attendeeType.simpleAttendee.canceled && (
            <Button
              title="Promote"
              size="xs"
              variant="outline"
              theme="create"
              onClick={() => onWaitlistPromotion(attendeeType.simpleAttendee)}
            />
          )}
          <div className={`${!onWaitlistPromotion ? "pr-4" : "pr-2"} pl-3 c-neutral-500`}>
            {attendeeType.selectedCount}
          </div>
        </div>
      )}
    </div>
  )
}

const attendeeTypeRow = css`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`

AttendeeTypeRow.propTypes = {
  attendeeType: object,
  maxSelectValue: number,
  eventAtMaximumCapacity: bool,
  onSimpleAttendeeChange: func,
  valueForSimpleAttendeeSelect: number,
  isEditing: bool,
  onWaitlistPromotion: func,
  inWaitlistSection: bool
}

export default AttendeeTypeRow
